var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Breadcrumbs from "./Breadcrumbs";
import PageHeadingMeta from "./PageHeadingMeta";
import PageHeadingActions from "./PageHeadingActions";
var PageHeading = function (_a) {
    var breadcrumbsContent = _a.breadcrumbsContent, title = _a.title, meta = _a.meta, actions = _a.actions;
    return (_jsxs("div", { children: [_jsx(Breadcrumbs, { breadcrumbsContent: breadcrumbsContent }), _jsxs("div", __assign({ className: "mt-2 lg:flex lg:items-center lg:justify-between" }, { children: [_jsxs("div", __assign({ className: "min-w-0 flex-1" }, { children: [_jsx("h2", __assign({ className: "text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight" }, { children: title })), _jsx(PageHeadingMeta, { items: meta })] })), actions && _jsx(PageHeadingActions, __assign({}, actions))] }))] }));
};
export default PageHeading;
